export default {
  reporterNameLabel: {
    id: 'report_illicit_content_reporter_name_label',
    defaultMessage: 'Name / Organization',
  },

  reporterEmailLabel: {
    id: 'report_illicit_content_reporter_email_label',
    defaultMessage: 'Email',
  },

  capacityLabel: {
    id: 'report_illicit_content_capacity_label',
    defaultMessage: 'Capacity',
  },

  capacityHelper: {
    id: 'report_illicit_content_capacity_helper',
    defaultMessage:
      'individual, company, authority, trusted flagger, rights holder, other',
  },

  countryLabel: {
    id: 'report_illicit_content_country_label',
    defaultMessage: 'Country of residence',
  },
}
